// client/src/components/common/LanguageSwitcher.js
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const [isSwitching, setIsSwitching] = useState(false);

    // Normalize language code (handles en-US, en-GB, etc.)
    const normalizeLanguage = (lang) => {
        if (!lang) return 'ka';
        const normalized = lang.toLowerCase().split('-')[0];
        return normalized === 'en' ? 'en' : 'ka';
    };

    const currentLanguage = normalizeLanguage(i18n.language);

    const toggleLanguage = async () => {
        if (isSwitching) return; // Prevent double-clicks

        setIsSwitching(true);
        const newLang = currentLanguage === 'ka' ? 'en' : 'ka';

        try {
            await i18n.changeLanguage(newLang);
            // Also update HTML lang attribute for accessibility
            document.documentElement.lang = newLang;
        } catch (error) {
            console.error('Language switch failed:', error);
        } finally {
            // Re-enable after a short delay
            setTimeout(() => setIsSwitching(false), 500);
        }
    };

    return (
        <button
            className="language-switcher"
            type="button"
            onClick={toggleLanguage}
            disabled={isSwitching}
            aria-label={`Switch to ${currentLanguage === 'ka' ? 'English' : 'Georgian'}`}
            title={`Switch to ${currentLanguage === 'ka' ? 'English' : 'Georgian'}`}
            style={{ opacity: isSwitching ? 0.6 : 1, cursor: isSwitching ? 'wait' : 'pointer' }}
        >
            {/* <span className="lang-flag">{currentLanguage === 'ka' ? '' : ''}</span> */}
            <span className="lang-text">{currentLanguage === 'ka' ? 'ENG' : 'GEO'}</span>
        </button>
    );
};

export default LanguageSwitcher;
